import type { ConsentState } from "./types.js";
import type { LocalStore } from "./storage.js";

const KEY = "consent";

export class ConsentManager {
  private state: ConsentState;
  private storage: LocalStore;
  private listeners = new Set<(s: ConsentState) => void>();

  constructor(storage: LocalStore, defaults: ConsentState = { analytics: true, marketing: false }) {
    this.storage = storage;
    const stored = storage.getJson<ConsentState>(KEY);
    this.state = stored ?? defaults;
  }

  get(): ConsentState {
    return { ...this.state };
  }

  set(next: Partial<ConsentState>): void {
    this.state = { ...this.state, ...next };
    this.storage.setJson(KEY, this.state);
    for (const fn of this.listeners) fn(this.state);
  }

  onChange(fn: (s: ConsentState) => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  /** Whether to send analytics events at all. */
  allowAnalytics(): boolean {
    return this.state.analytics === true;
  }
}
